import React from "react";
import { Modal, Card, Row, Col, Typography, Tag, Space, Button } from "antd";
import dayjs from "dayjs";
import { FORMAT_DATE, PAYMENT_METHOD } from "../../../constants/constants";
import { formatNumber } from "../../../utils/funcHelper";
import { CloseOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const PaymentDetailModal = ({ isOpen, onClose, record }) => {
  const status = record?.status; // 'completed' | 'cancelled'
  const isCancelled = status === "cancelled";
  const statusColor = status === "completed" ? "green" : "red";
  const statusText = status === "completed" ? "Đã thanh toán" : "Đã huỷ";

  const paymentMethod = PAYMENT_METHOD.find(method => method.value === record?.payment_method)?.label || "-";

  const paymentDate = record?.payment_date
    ? dayjs(record.payment_date).format(FORMAT_DATE.DDMMYYYY)
    : "-";

  const cancelledAt = record?.cancelled_at
    ? dayjs(record.cancelled_at).format(FORMAT_DATE.DDMMYYYY)
    : null;

  return (
    <Modal
      title="Chi tiết phiếu thanh toán"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={720}
      destroyOnClose
    >
      <Space direction="vertical" style={{ width: "100%" }} size={12}>
        <Card size="small" style={{ borderRadius: 8 }}>
          <Title level={5} style={{ marginBottom: 8 }}>Thông tin phiếu</Title>
          <Row gutter={16}>
            <Col span={12}>
              <Text><strong>Mã phiếu:</strong> {record?.payment_code || "-"}</Text>
            </Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <Text><strong>Ngày:</strong> {paymentDate}</Text>
            </Col>
          </Row>
          <Row gutter={16} style={{ marginTop: 8 }}>
            <Col span={12}>
              <Text><strong>Trạng thái:</strong> <Tag color={statusColor}>{statusText}</Tag></Text>
            </Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <Text><strong>Số tiền:</strong> <strong>{formatNumber(record?.amount || 0, 0)} đ</strong></Text>
            </Col>
          </Row>
        </Card>

        <Card size="small" style={{ borderRadius: 8 }}>
          <Title level={5} style={{ marginBottom: 8 }}>Chi tiết thanh toán</Title>
          <Row gutter={16}>
            <Col span={12}>
              <Text><strong>Phương thức:</strong> {paymentMethod}</Text>
            </Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <Text><strong>Người thu tiền:</strong> {record?.received_by_name || "-"}</Text>
            </Col>
          </Row>
          <Row gutter={16} style={{ marginTop: 8 }}>
            <Col span={24}>
              <Text><strong>Nội dung:</strong> {record?.note || "-"}</Text>
            </Col>
          </Row>
        </Card>

        {isCancelled && (
          <Card size="small" style={{ borderRadius: 8 }}>
            <Title level={5} style={{ marginBottom: 8 }}>Thông tin huỷ phiếu</Title>
            <Row gutter={16}>
              <Col span={12}>
                <Text><strong>Người huỷ:</strong> {record?.cancelled_by_name || "-"}</Text>
              </Col>
              <Col span={12} style={{ textAlign: "right" }}>
                <Text><strong>Thời gian huỷ:</strong> {cancelledAt || "-"}</Text>
              </Col>
            </Row>
            <Row gutter={16} style={{ marginTop: 8 }}>
              <Col span={24}>
                <Text><strong>Lý do huỷ:</strong> {record?.cancelled_reason || "-"}</Text>
              </Col>
            </Row>
          </Card>
        )}

        <Row justify="end">
          <Button onClick={onClose} icon={<CloseOutlined />}>Đóng</Button>
        </Row>
      </Space>
    </Modal>
  );
};

export default React.memo(PaymentDetailModal);